export default __webpack_public_path__ + "static/media/appRightImg.f5d74104.png";